// //------------------------------------------------------------------------------------

// import { useState } from 'react';
// import { ExpandLess, ExpandMore } from '../Icons/Icons';
// import './Pagination.scss';

// //------------------------------------------------------------------------------------

// const Pagination = ({ getTotalItems, getItemsPerPage, getPageNumber, activePage }) => {
//     const [totalItems, setTotalItems] = useState(getTotalItems);
//     const [itemsPerPage, setItemsPerPage] = useState(getItemsPerPage);

//     let totalButtonsCount = Math.ceil(totalItems / itemsPerPage);
//     let totalButtonsData = [];

//     for (let i = 1; i <= totalButtonsCount; i++) {
//         totalButtonsData.push({
//             isActive: i == activePage ? true : false,
//             number: i,
//         });
//     }

//     console.log("pagi - ",getTotalItems, getItemsPerPage, getPageNumber, activePage);

//     let previousClassName = activePage <= 1 ? 'pagination previous disabled' : 'pagination previous';
//     let nextClassName = activePage >= totalButtonsCount ? 'pagination next disabled' : 'pagination next';
//      console.log("total button data - ",totalButtonsData);
//      console.log("active page - ",activePage);
//      console.log("totalbuttoncnt - ",totalButtonsCount);
//     return (
//         <>
//             {
//                 totalButtonsCount != 0 && totalButtonsData.length != 1 &&
//                 <div className='pagination-container'>
//                     <div className={previousClassName} onClick={() => getPageNumber(activePage - 1)}>
//                         <ExpandLess />
//                     </div>
//                     {
//                         totalButtonsData?.map((data) => {
                            
//                             let className = data.isActive ? 'pagination active' : 'pagination';
//                             return <div key={data.number} className={className} onClick={() => getPageNumber(data.number)}>{data.number}</div>
//                         })
//                     }
//                     <div className={nextClassName} onClick={() => getPageNumber(activePage + 1)}>
//                         <ExpandMore />
//                     </div>
//                 </div>
//             }
//         </>
//     )
// }

// export default Pagination;

// //------------------------------------------------------------------------------------


import React from 'react';
import { ExpandLess, ExpandMore } from '../Icons/Icons';
import './Pagination.scss';

const Pagination = ({ getTotalItems, getItemsPerPage, getPageNumber, activePage }) => {
    const totalItems = getTotalItems;
    const itemsPerPage = getItemsPerPage;

    if (totalItems <= 0 || itemsPerPage <= 0) {
        return null; // No pagination needed for invalid input
    }

    const totalButtonsCount = Math.ceil(totalItems / itemsPerPage);

    const generatePageNumbers = () => {
        const pageNumbers = [];
        const maxButtonsToShow = 5; // Limit the number of page buttons shown
        const halfRange = Math.floor(maxButtonsToShow / 2);

        let start = Math.max(1, activePage - halfRange);
        let end = Math.min(totalButtonsCount, activePage + halfRange);

        if (end - start + 1 < maxButtonsToShow) {
            if (start === 1) {
                end = Math.min(totalButtonsCount, start + maxButtonsToShow - 1);
            } else if (end === totalButtonsCount) {
                start = Math.max(1, end - maxButtonsToShow + 1);
            }
        }

        for (let i = start; i <= end; i++) {
            pageNumbers.push(i);
        }

        return pageNumbers;
    };

    const pageNumbers = generatePageNumbers();

    const handlePreviousClick = () => {
        if (activePage > 1) {
            getPageNumber(activePage - 1);
        }
    };

    const handleNextClick = () => {
        if (activePage < totalButtonsCount) {
            getPageNumber(activePage + 1);
        }
    };

    return (
        <div className="pagination-container">
            <div
                className={`pagination previous ${activePage <= 1 ? 'disabled' : ''}`}
                onClick={handlePreviousClick}
            >
                <ExpandLess />
            </div>
            {pageNumbers.map((page) => (
                <div
                    key={page}
                    className={`pagination ${page === activePage ? 'active' : ''}`}
                    onClick={() => getPageNumber(page)}
                >
                    {page}
                </div>
            ))}
            <div
                className={`pagination next ${activePage >= totalButtonsCount ? 'disabled' : ''}`}
                onClick={handleNextClick}
            >
                <ExpandMore />
            </div>
        </div>
    );
};

export default Pagination;









